import { Component } from '@angular/core'
import { FuseSplashScreenService } from './core/services/splash-screen.service'
import { TranslateService } from '@ngx-translate/core'
import { FuseTranslationLoaderService } from './core/services/translation-loader.service'

import { FuseNavigationService } from './core/components/navigation/navigation.service'
import { FuseNavigationModel } from './navigation/navigation.model'
import { localeEN } from './navigation/i18n/en'
import { localeNL } from './navigation/i18n/nl'
import { Subscription } from 'rxjs/Subscription'
import { AdministrationModel } from './main/models/administration.model'

@Component({
  selector: 'fuse-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  onAdminSelected: Subscription

  constructor(
    private fuseNavigationService: FuseNavigationService,
    private fuseSplashScreen: FuseSplashScreenService,
    private translate: TranslateService,
    private translationLoader: FuseTranslationLoaderService,
  ) {
    // Add languages
    this.translate.addLangs(['en', 'nl'])

    // Set the default language
    this.translate.setDefaultLang('nl')

    // Use a language
    this.translate.use('nl')

    // Set the navigation model
    this.fuseNavigationService.setNavigationModel(new FuseNavigationModel())

    // Set the navigation translations
    this.translationLoader.loadTranslations(localeNL, localeEN)

    // this.onAdminSelected =
    //   this.administrationService
    //     .onCurrentAdministationChanged
    //     .subscribe(administration => {
    //       if(administration !== undefined){
    //         const ledgerNav = this.fuseNavigationService.getNavigationItem('ledger');
    //         ledgerNav.title = administration.name;
    //
    //         const ledgerUsersNav = this.fuseNavigationService.getNavigationItem('ledger.adminUsers');
    //
    //         if(ledgerUsersNav === undefined) {
    //           this.fuseNavigationService.addNavigationItem('ledger', this.addUsersMenu(administration));
    //           this.fuseNavigationService.addNavigationItem('ledger', this.addDocumentsMenu(administration));
    //
    //         }else{
    //           const ledgerDocumentsNav = this.fuseNavigationService.getNavigationItem('ledger.adminDocuments');
    //
    //           ledgerUsersNav.url = '/ledger/' + administration.id + '/users';
    //           ledgerDocumentsNav.url = '/ledger/' + administration.id + '/documents';
    //
    //         }
    //
    //       }
    //
    //     })
  }

  private addUsersMenu(administration: AdministrationModel) {
    return {
      id: 'adminUsers',
      title: 'NAV.USERS',
      type: 'item',
      icon: 'supervisor_account',
      url: '/ledger/' + administration.id + '/users',
    }
  }

  private addDocumentsMenu(administration: AdministrationModel) {
    return {
      id: 'adminDocuments',
      title: 'NAV.DOCUMENTS',
      type: 'item',
      icon: 'insert_drive_file',
      url: '/ledger/' + administration.id + '/documents',
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts